import ContainedIcon from '@/components/ContainedIcon';
import CanopyIconBase from '@/components/Icons/CanopyIcon';
import { SharedEndpointModelFamily } from '@/graphql';

import {
  mapIconSizeToSize,
  mapModelFamilyToIconColor,
  mapModelFamilyToIconContainerColor,
} from '../utils';
import { SharedEndpointIconProps, SharedEndpointIconSize } from './types';

function CanopyIcon({ size }: SharedEndpointIconProps) {
  const [containerSize, iconSize] = mapIconSizeToSize(size);

  return (
    <ContainedIcon
      size={containerSize}
      color={mapModelFamilyToIconContainerColor(SharedEndpointModelFamily.Canopy)}
      borderRadius={size === SharedEndpointIconSize.XSMALL ? 6 : 8}
    >
      <CanopyIconBase
        sx={{
          width: iconSize,
          height: iconSize,
          color: mapModelFamilyToIconColor(SharedEndpointModelFamily.Canopy),
        }}
      />
    </ContainedIcon>
  );
}

export default CanopyIcon;
